/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_TitleInputs */

const en_mk_how_title = /** @type {(inputs: Mk_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From idea to handover in four steps`)
};

const id_mk_how_title = /** @type {(inputs: Mk_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari ide sampai serah terima dalam empat langkah`)
};

/**
* | output |
* | --- |
* | "From idea to handover in four steps" |
*
* @param {Mk_How_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_title = /** @type {((inputs?: Mk_How_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_title(inputs)
	return en_mk_how_title(inputs)
});